<template>
  <v-container >    
    <div v-if="loading" >
      <v-skeleton-loader  type="card"></v-skeleton-loader>
    </div>
    <div v-else>
     <div v-if="content">
        <object style="width:100%;height:900px" id="pdf_viewer" :data="content" type="application/pdf" />
      </div>
    </div>
  </v-container>
</template>

<script>
import MeetingPdfViewer from "./mixin/MeetingPdfViewer";

export default {
  mixins: [MeetingPdfViewer]
};
</script>
<style lang="scss" scoped>


</style>


// WEBPACK FOOTER //
// src/pages/meetingpdfviewer/MeetingPdfViewer.vue